const topics = [
  { name: '暗网入门', count: '2.8k', hot: true },
  { name: 'Tor浏览器', count: '2.1k', hot: true },
  { name: '暗网安全', count: '1.9k', hot: true },
  { name: '深度网导航', count: '1.6k', hot: false },
  { name: '吃瓜爆料', count: '1.5k', hot: true },
  { name: '匿名投稿', count: '1.3k', hot: false },
  { name: 'VPN推荐', count: '1.2k', hot: false },
  { name: '暗网网址', count: '980', hot: false },
  { name: 'PGP加密', count: '850', hot: false },
  { name: '移动端访问', count: '720', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 text-center mb-3">
          热门话题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10 max-w-lg mx-auto">
          暗网社区最受关注的话题标签，点击探索你感兴趣的内容方向
        </p>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href={topic.hot ? '#carousel' : '#updates'}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500/10 border-accent-500/20 text-accent-400 hover:bg-accent-500/20'
                  : 'bg-background-100 border-background-200/60 text-foreground-400 hover:text-foreground-200 hover:border-background-300'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              <span className="font-medium">{topic.name}</span>
              <span className="text-[10px] opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}